<template>
<el-dialog
  title="企业列表"
  :visible.sync="dialogVisible"
  append-to-body
  class="dialog_"
  @close="closeForm"
  width="1000px">
  <div class="container">
    <div style="width: 100%">
      <div class="fl-wrap mg-tp-sm">
        <div class="search-item">
          <span class="span">行业监管部门</span>
          <el-cascader
            ref="departmentTree"
            size="mini"
            :show-all-levels="false"
            v-model="searchForm.path"
            @change="change"
            :options="departmentData"
            :props="{ checkStrictly: true, label: 'name', value: 'id' }"
            @clear="searchForm.path=null"
            clearable></el-cascader>
        </div>
        <div class="search-item">
          <span class="span">企业名称</span>
          <el-input clearable size="mini" style="width:160px;margin-right:15px;" v-model="searchForm.name"
            placeholder="请输入企业名称"></el-input>
        </div>
        <div class="search-item">
          <span class="span">行业类型</span>
          <el-cascader
            @change="selectControlId"
            filterable collapse-tags
            size="mini" clearable
            :show-all-levels="false"
            :props="{ multiple: true }"
            v-model="searchForm.control_id"
            :options="industryOptions"></el-cascader>
        </div>
        <selectArea :area.sync="searchForm.area_id" :town.sync="searchForm.town" :village.sync="searchForm.village"></selectArea>
      </div>
      <div style="display: flex;margin-bottom: 10px;">
        <el-button style="height: 28px" size="mini" type="primary" @click="reset">重置</el-button>
        <el-button class="mg-lf-sm" style="height: 28px" size="mini" type="primary" @click="search">查询</el-button>
        <el-button class="mg-lf-sm" style="height: 28px" size="mini" type="primary" @click="heightSearch">高级查询</el-button>
      </div>
      <div v-show="advancedSearch">
        <div class="fl-wrap mg-tp-sm">
          <el-checkbox class="checkbox" v-model="searchForm.company_level_two" true-label="2"
            >存在重大隐患单位</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.company_level_one" true-label="1"
            >存在一般隐患单位</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_supervision_check" true-label="1"
            >加入监督检查库单位</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_fire_safety_focus" true-label="1"
            >属于消防重点单位</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_fire_danger" true-label="1"
            >属于火灾高危单位</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_safety_insurance" true-label="1"
            >购买安责险</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_has_limited_space_task" true-label="1"
            >是否涉及有限空间作业</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_overdue_safety_standard" true-label="1"
            >安全标准化证书过期</el-checkbox>
          <!--应急 -->
          <el-checkbox class="checkbox" v-model="searchForm.is_metal_company" true-label="1"
            >金属冶炼企业</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_deep_well_process" true-label="1"
            >铝加工（深井铸造）企业</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_has_metal_dust" true-label="1"
            >涉粉30人以上和铝镁等金属粉尘涉爆企业</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_has_ammonia" true-label="1"
            >涉氨制冷企业</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_major_hazard_source" true-label="1"
            >构成重大危险源</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_has_chlorine" true-label="1"
            >涉氯企业</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.risk_level" true-label="1"
            >重大安全风险等级（红色）企业</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_no_safety_standard" true-label="1"
            >未创建安全标准化</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_three_ts_unfinished" true-label="1"
            >三同时未完成</el-checkbox>
          <el-checkbox class="checkbox" v-model="searchForm.is_has_dust" true-label="1"
            >涉及涉爆粉尘</el-checkbox>
        </div>
      </div>
      <div>
        <el-table
          @select="select"
          @select-all="selectAll"
          ref="multipleTable"
          highlight-current-row
          :data="tableData"
          v-loading="loading"
          style="width: 100%"
          :header-cell-style="{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'}"
          :cell-style="{padding: '5px 0',color: '#303133'}"
          border
          stripe>
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            prop="name"
            label="企业名称"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="credit_code"
            label="统一信用代码"
            show-overflow-tooltip
            min-width="150">
          </el-table-column>
          <el-table-column
            prop="area.name"
            :formatter="(row) => row.area && row.area ? row.area: '--'"
            show-overflow-tooltip
            label="区域"
            width="200">
            <template slot-scope="{row}">
              {{row.area}}-{{row.town}}{{row.village ? '-' + row.village : ''}}
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <div style="float:right;padding:10px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 100, 500, 1000, 5000, 10000]"
                :page-size="10"
                layout="sizes, total, prev, pager, next, jumper"
                :total="totalCount">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
    <el-button size="mini" type="primary" @click="save">确 定</el-button>
  </span>
</el-dialog>
</template>

<script>
import selectArea from '@/components/selectArea/selectArea'
import {industryOptions, levelOptions} from '../../Util/commonOptions'
import Search from '@/Util/Search'
import {api} from '@/api/api'
export default {
  components: {
    Search,
    selectArea
  },
  data () {
    return {
      searchForm:{
        area_id: null,
        town: null,
        village: null,
        name:null,
        control_id: null,
        path:null,

        company_level_one:null, //存在一般隐患单位
        company_level_two:null, //存在重大隐患单位
        is_supervision_check: null, //加入监督检查库单位
        risk_level: null, // 重大安全风险等级（红色）企业
        is_metal_company: null, // 金属冶炼企业
        is_deep_well_process: null, // 铝加工（深井铸造）企业
        is_has_metal_dust: null, // 涉粉30人以上和铝镁等金属粉尘涉爆企业
        is_has_ammonia: null, // 涉氨制冷企业
        is_has_chlorine: null, // 涉氯企业
        is_has_limited_space_task: null, // 是否涉及有限空间作业
        is_major_hazard_source: null, // 是否构成重大危险源
        development_area_name: null, // 企业园区
        is_no_safety_standard: null, // 未创建安全标准化
        is_overdue_safety_standard: null, // 安全标准化过期
        is_three_ts_unfinished: null, //  三同时未完成
        is_manager_no_train: null, // 主要管理或负责人没有培训
        is_has_dust: null, //涉及涉爆粉尘
        is_fire_safety_focus: null, // 属于消防重点单位
        is_fire_danger:null, //属于火灾高危单位
        is_safety_insurance: null, // 购买安责险
      },
      industryOptions, // 企业类型
      search_control_id: '',
      dialogVisible: true,
      staff: null,
      loading: false,
      jobOptions: [],
      tableData: [],
      checkedData: null, // 选中的节点
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      parent_node_id: 0, // 父级ID
      parent_node_label: null, // 父级名称
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      callback: null,
      SelectionAll: {},
      SelectionTable: [],
      responsible_person: null,
      advancedSearch: false,

    }
  },
  mounted () {
    this.getCompanyList()
    this.getDepartmentTreeList()
  },
  methods: {
    heightSearch () {
      this.advancedSearch = !this.advancedSearch
      this.searchForm = {
        area_id: null,
        town: null,
        village: null,
        name:null,
        control_id: null,
        path:null,
        
        company_level_one:null, //存在一般隐患单位
        company_level_two:null, //存在重大隐患单位
        is_supervision_check: null, //加入监督检查库单位
        risk_level: null, // 重大安全风险等级（红色）企业
        is_metal_company: null, // 金属冶炼企业
        is_deep_well_process: null, // 铝加工（深井铸造）企业
        is_has_metal_dust: null, // 涉粉30人以上和铝镁等金属粉尘涉爆企业
        is_has_ammonia: null, // 涉氨制冷企业
        is_has_chlorine: null, // 涉氯企业
        is_has_limited_space_task: null, // 是否涉及有限空间作业
        is_major_hazard_source: null, // 是否构成重大危险源
        development_area_name: null, // 企业园区
        is_no_safety_standard: null, // 未创建安全标准化
        is_overdue_safety_standard: null, // 安全标准化过期
        is_three_ts_unfinished: null, //  三同时未完成
        is_manager_no_train: null, // 主要管理或负责人没有培训
        is_has_dust: null, //涉及涉爆粉尘
        is_fire_safety_focus: null, // 属于消防重点单位
        is_fire_danger:null, //属于火灾高危单位
        is_safety_insurance: null, // 购买安责险
      }
    },
    change (val) {
      let data = this.$refs.departmentTree.getCheckedNodes(true)
      if(data && data.length>0){
        this.searchForm.department_area_id = data[0].data.area_id
        this.searchForm.department_type_id = data[0].data.department_type_id
        this.searchForm.tree_id = data[0].data.id
      }
    },
    getDepartmentTreeList () {
      this.$http.post(api.getDepartmentTreeList, {}).then(res => {
        if (res.data.code == 0) {
          this.departmentData = res.data.data
          this.departmentData.forEach(v => {
            v.name = `${v.name}(${v.area_name})`
          })
        }
      })
    },
    selectControlId (val) {
      this.search_control_id = val.map(v => {
        return v[1]
      })
      this.build_industry = val.map(v => {
        return v[0]
      })
    },
    reset() {
      for(let key in this.searchForm) {
        this.searchForm[key] = null
      }
      this.search()
    },
    search() {
      this.currentPage = 1
      if(this.searchForm.path!=null && this.searchForm.path.length==0){
        this.searchForm.path=null
      }
      this.getCompanyList()
    },
    deleteStaff (row, index) {
      this.select({}, row)
      this.$nextTick(() => {
        this.getCompanyList()
      })
    },
    closeForm () {
      this.staff = null
      this.checkedData = null
      // this.$refs['table'].setCurrentRow()
      this.$el.parentNode.removeChild(this.$el);
    },
    save () {
      if (this.SelectionTable.length == 0) {
        return this.$message({
          type: 'warning',
          message: '请选择企业'
        })
      }
      if (this.callback && typeof(this.callback) === 'function') {
        this.callback(this.SelectionTable)
      }
      // this.$emit('getStaff', staff)
      this.dialogVisible = false
    },
    currentChange (currentRow) {
      if (currentRow) {
        this.staff = currentRow
      }
    },
    // // 获取员工账号列表
    getCompanyList () {
      let params = {
        page_index: this.currentPage,
        page_size: this.pageSize
      }
      for (let key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          params[key] = this.searchForm[key]
        }
      }
      if (params.control_id) {
        params.control_id = params.control_id.map(v => {
          return v[1]
        })
      }
      this.loading = true
      this.$http.post(
        api['getCompanyList'],
        params
      ).then(response => {
        this.tableData = response.data.data
        this.$nextTick(() => {
          this.checkSelect()
        })
        this.totalCount = response.data.page_info.total_num
        this.loading = false
      }).catch((error) => {
        console.log(error)
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getCompanyList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCompanyList()
    },
    select (selection, row) {
      for (let key in this.SelectionAll) {
        if (key == row.id) {
          delete this.SelectionAll[key]
          this.SelectionTable = Object.values(this.SelectionAll)
          return
        }
      }
      this.SelectionAll[row.id] = row
      this.SelectionTable = Object.values(this.SelectionAll)
    },
    selectAll (select) {
      for (let row of this.tableData) {
        if (select.length === 0) {
          delete this.SelectionAll[row.id]
        } else {
          this.SelectionAll[row.id] = row
        }
      }
      this.SelectionTable = Object.values(this.SelectionAll)
    },
    // 每次刷新时检查是否有选项，并设置已选中
    checkSelect () {
      for (let row of this.tableData) {
        if (this.SelectionAll.hasOwnProperty(row.id)) {
          this.$refs.multipleTable.toggleRowSelection(row,true)
        }
      }
    },
  }
}
</script>

<style scoped>
  .container {
    display: flex;
    flex-wrap: nowrap;
  }
  .span {
    font-size: 14Px;
    line-height: 32Px;
    margin:0 5Px 10Px 0;
  }
  .item {
    width: 160Px;
    margin:0 15Px 10Px 0;
  }
  .left {
    margin-left: 15Px;
  }
  .title {
    font-size: 18Px;
    font-weight: 900;
  }
  .fl-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .mg-tp-sm {
    margin: 5Px 0;
  }
  .checkbox {
    margin-bottom: 5Px;
  }
  .span {
    margin: 8Px;
  }
  .search-item {
    margin-bottom: 8Px;
  }
  .dialog_ >>> .el-dialog__body {
    padding: 0 30Px;
  }
</style>



// WEBPACK FOOTER //
// src/components/selectCompany/selectCompanyDialog.vue